const auth = async ({next, store, exit}) => { return store.getters['auth/currentUser'].userId ? next() : exit({name: 'auth'}); }

export default auth;